<svg
    [ngStyle]="Style"
    viewBox="0 0 509.514 191.61"
    xmlns="http://www.w3.org/2000/svg"
    [class]="ClassList ? ClassList : ''"
>
  <defs>
    <style>
      .cls-1 {
        fill: #229799;
      }
      .cls-2 {
        fill: #23305a;
      }
    </style>
  </defs>
  <g id="Layer_2" data-name="Layer 2">
    <g id="Layer_1-2" data-name="Layer 1">
      <path
        class="cls-1"
        d="M413.02,141.984h0V96.362a46.477,46.477,0,0,1,3.662-18.184,47.012,47.012,0,0,1,16.961-20.585,46.409,46.409,0,0,1,12.206-5.87,47.554,47.554,0,0,1,14.039-2.1h0V0h0a96.285,96.285,0,0,0-96.494,96.362V191.61H413.02Z"
      />
      <path
        class="cls-1"
        d="M459.888,49.777h35.439a14.186,14.186,0,0,1,14.186,14.186V191.61a0,0,0,0,1,0,0H459.888a0,0,0,0,1,0,0V49.777A0,0,0,0,1,459.888,49.777Z"
      />
      <path
        class="cls-1"
        d="M0,132.254v-13.79q0-3.529.831-4.363t4.364-.833H17.32q3.531,0,4.362.833t.833,4.363v11.059q0,7.5,3.6,11.575t11.127,4.08H77.608q7.06,0,9.526-2.578a8.066,8.066,0,0,0,2.465-5.683,10.134,10.134,0,0,0-1.2-4.93,14.811,14.811,0,0,0-3.53-4.163,58.2,58.2,0,0,0-5.6-4.1Q76.01,121.6,71.879,119q-2.2-1.532-2.2-3,0-1.332,1.931-4.063l4-6a17.032,17.032,0,0,1,1.965-2.6,2.7,2.7,0,0,1,1.965-.933,2.96,2.96,0,0,1,1.234.333c.466.223.967.467,1.5.733q5.461,3.4,9.426,6.262t7.228,4.93a31.565,31.565,0,0,0,6.528,3.2A23.389,23.389,0,0,0,113.115,119h9.927q3,0,3.7,1.3a10.066,10.066,0,0,1,.7,4.43v7.261a10.06,10.06,0,0,1-.7,4.43q-.7,1.3-3.7,1.3H111.449a51.7,51.7,0,0,1-.8,8.727,19.756,19.756,0,0,1-11.391,14.923q-5.13,2.53-13.59,2.531H37.637a57.022,57.022,0,0,1-17.686-2.365A29.727,29.727,0,0,1,8.36,154.87a25.123,25.123,0,0,1-6.395-10.059A38.651,38.651,0,0,1,0,132.254ZM37.5,177.3q0-2.921.7-3.666t3.432-.748h9.392q2.733,0,3.4.748t.666,3.666V187.2q0,2.919-.666,3.666t-3.4.748H41.635q-2.733,0-3.432-.748t-.7-3.666Zm21.584,0q0-2.921.6-3.666t3.33-.748h9.594q2.73,0,3.4.748t.666,3.666V187.2q0,2.919-.666,3.666t-3.4.748H63.018q-2.731,0-3.33-.748t-.6-3.666Z"
      />
      <path
        class="cls-1"
        d="M118.645,131.987v-7.261a10.1,10.1,0,0,1,.7-4.43q.7-1.3,3.675-1.3h14.771a20.422,20.422,0,0,1-3.284-8.161,52.912,52.912,0,0,1-.67-8.293,31.971,31.971,0,0,1,1.9-10.792,27.736,27.736,0,0,1,5.8-9.56,30.246,30.246,0,0,1,9.627-6.895,31.461,31.461,0,0,1,13.39-2.664H178q3,0,3.7,1.3a10.074,10.074,0,0,1,.7,4.431v7.261a10.1,10.1,0,0,1-.695,4.43q-.7,1.3-3.679,1.3h-8.418q-6.627,0-9.942,4.03a14.585,14.585,0,0,0-3.313,9.56,29.332,29.332,0,0,0,.4,4.663,11.226,11.226,0,0,0,1.826,4.563,10.714,10.714,0,0,0,4.081,3.464A15.252,15.252,0,0,0,169.621,119h16.326q2.982,0,3.68,1.3a10.083,10.083,0,0,1,.7,4.43v7.261a10.077,10.077,0,0,1-.7,4.43q-.7,1.3-3.69,1.3h-62.9q-2.993,0-3.691-1.3A10.092,10.092,0,0,1,118.645,131.987Z"
      />
      <path
        class="cls-1"
        d="M204.58,133.32V43.5q0-3.4.837-4.23t4.257-.833H222q3.416,0,4.254.833t.837,4.23V119h10.166q2.971,0,3.631.7t.66,3.7v9.793q0,3.132-.666,3.83t-3.663.7H209.11q-3.134,0-3.83-.666T204.58,133.32Z"
      />
      <path
        class="cls-1"
        d="M232.761,131.987v-7.261a10.048,10.048,0,0,1,.7-4.43q.7-1.3,3.7-1.3h5.995q4.532,0,5.53-1.765t1-6.1V89.552q0-3.53.832-4.363c.557-.555,2.009-.833,4.365-.833h12.19q3.531,0,4.331.833t.8,4.363V111.8a7.979,7.979,0,0,0,1.632,5.162q1.632,2.032,5.5,2.032a7.768,7.768,0,0,0,5.294-1.565q1.764-1.565,1.766-6.3V89.552a22.627,22.627,0,0,1,.134-2.8,2.868,2.868,0,0,1,.637-1.565,2.353,2.353,0,0,1,1.507-.7,22.959,22.959,0,0,1,2.816-.133h12.33q3.417,0,4.255.833t.839,4.363V111.8a7.606,7.606,0,0,0,1.755,5.162Q312.415,119,317.719,119h4.374V82.025q0-3.4.8-4.2t4.4-.8h12.124q3.531,0,4.363.8t.833,4.2v50.629q0,3.4-.831,4.23t-4.359.832H318.13a13.94,13.94,0,0,1-12.51-6.128,21.045,21.045,0,0,1-9.081,5.029,43.522,43.522,0,0,1-10.018,1.1,39.641,39.641,0,0,1-7-.532,22.733,22.733,0,0,1-5-1.433,15.015,15.015,0,0,1-3.432-2,18.222,18.222,0,0,1-2.3-2.165,15.737,15.737,0,0,1-8.027,5.1,40.237,40.237,0,0,1-9.293,1.032H237.157q-3,0-3.7-1.3A10.042,10.042,0,0,1,232.761,131.987Z"
      />
      <path
        class="cls-2"
        d="M197.4,163.645a30.638,30.638,0,0,0-12.716-3.5c-3.287,0-5.443,1.185-5.443,3.556,0,1.562.809,2.209,5.982,3.61l3.771,1.024c8.567,2.424,12.663,4.418,12.932,11.369,0,7.6-6.089,11.908-15.948,11.908a32.153,32.153,0,0,1-17.62-5.119l3.879-6.466a30.6,30.6,0,0,0,14.441,4.149c3.825,0,6.142-1.185,6.142-3.987,0-1.886-1.024-2.641-5.927-3.826l-3.987-1.024c-8.783-2.155-12.771-4.364-12.933-10.992,0-3.825,1.4-6.681,4.258-8.621s6.574-2.909,11.153-2.909a31.454,31.454,0,0,1,15.68,4.094Z"
      />
      <path
        class="cls-2"
        d="M234.361,183.635H217.873l-2.856,7.436h-9.968l15.357-37.718h11.261l15.518,37.718h-9.968Zm-2.747-7-5.55-14.386-5.5,14.386Z"
      />
      <path
        class="cls-2"
        d="M280.056,183.635H263.568l-2.856,7.436h-9.968L266.1,153.353h11.261l15.518,37.718h-9.968Zm-2.747-7-5.55-14.386-5.5,14.386Z"
      />
      <path
        class="cls-2"
        d="M328.984,160.951H307.431v7.382h19.991v7.274H307.431v7.813h21.93v7.651h-30.5V153.353h30.12Z"
      />
      <path class="cls-2" d="M344.611,191.071h-8.567V153.353h8.567Z" />
    </g>
  </g>
</svg>
